import i18n from 'services/base/i18n';

export default {
  // Button to save the changes to the parental control rules
  save: () => i18n.pgettext('Pages|VPN Client', 'SAVE'),

  // Label on the button to delete the vpn client
  delete: () => i18n.pgettext('Pages|VPN Client', 'DELETE'),

  // Placeholder text for the name of the vpn client
  nameLabel: () => i18n.pgettext('Pages|VPN Client', 'CLIENT NAME'),

  // Instructions on what to do with the VPN client that was created
  instructions: () => i18n.pgettext('Pages|VPN Client', 'To get started, press the save button so that your Pangolin can generate the secret access credentials.'),

  // Error displayed when the user tries to set an invalid name for the rule
  invalidName: () => i18n.pgettext('Pages|VPN Client', 'Invalid name'),

  // Label on the QR Code people need to scan on the vpn app
  qrLabel: () => i18n.pgettext('Pages|VPN Client', 'SCAN ME'),

  // Instructions on the mnemonic to let people know they can copy the text by tapping
  mnemonicHelp: () => i18n.pgettext('Pages|VPN Client', '(Tap to Copy)'),

  // Label on the button to switch to the secret phrase
  showMnemonic: () => i18n.pgettext('Pages|VPN Client', 'Show Secret Phrase'),

  // Label on the button to switch to the qr code
  showQR: () => i18n.pgettext('Pages|VPN Client', 'Show QR Code'),

  // Title of the section which displays device info
  hostTitle: () => i18n.pgettext('Pages|VPN Client', 'DEVICE INFO'),

  // Label for the IP Address of the associated device
  ipAddressLabel: () => i18n.pgettext('Pages|VPN Client', 'IP ADDRESS'),

  // Label for the VPN Client Status of the associated device
  clientStatus: () => i18n.pgettext('Pages|VPN Client', 'CLIENT STATUS'),

  // Label for the name of the pangolin this vpn client is connected to
  connectedToLabel: () => i18n.pgettext('Pages|VPN Client', 'CONNECTED TO'),

  // Label for when this vpn client was last seen connected
  lastSeenLabel: () => i18n.pgettext('Pages|VPN Client', 'LAST SEEN'),

  // This string gets displayed if the Pangolin doesn't remember when it last saw this device
  lastSeenUnknown: () => i18n.pgettext('Pages|VPN Client', 'Unknown'),

  // Label on the button to delete the vpn client
  goToDevice: () => i18n.pgettext('Pages|VPN Client', 'GO TO DEVICE'),

  // Message to display on successful clipboard copy
  copySuccess: () => i18n.pgettext('Pages|VPN Client', 'Copied to clipboard!'),

  // Message to display on failed clipboard copy
  copyError: () => i18n.pgettext('Pages|VPN Client', 'Failed to copy to clipboard!'),
};
